import { Grid, styled } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

export const Title = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "24px",
  letterSpacing: "0.5px",
  color: colors.gray600,
}));

export const WrapperPlatforms = styled("div")(() => ({
  padding: "12px 24px",
  borderTop: `1px solid ${colors.gray200}`,
  width: "100%",
}));

export const WrapperTitleWithLoading = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 8,
  marginBottom: 8,
  "& > span": {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    letterSpacing: "0.5px",
    color: colors.gray600,
  },
}));

export const OptionsWrapper = styled("div")(() => ({
  background: colors.gray50,
  border: `1px solid ${colors.gray200}`,
  borderRadius: "8px",
  maxWidth: "100%",
  overflow: "hidden",
  "& > div:last-child": {
    borderBottom: "none",
  },
}));

export const GeneralWrapper = styled(Grid)(() => ({
  padding: "24px 32px",
  maxWidth: "100%",
}));

const styles = makeStyles(() => ({
  contentSection: {
    margin: "0px !important",
    padding: "12px",
    maxWidth: "100%",
    overflow: "hidden",
    "& > .MuiGrid-item": {
      maxWidth: "100%",
      paddingLeft: "0 !important",
      paddingRight: "0 !important",
      paddingTop: "0 !important",
    },
  },
  wrapperContentPlatforms: {
    maxWidth: "100%",
    minWidth: 0,
  },
  sectionSpacing: {
    marginBottom: 24,
  },
}));

export default styles;
